/**
 * Import Dependency
 */
import { handleActions } from 'redux-actions'
import collection from 'lodash/collection'
import update from 'immutability-helper'
import lang from 'lodash/lang'
import array from 'lodash/array'
import object from 'lodash/object'

/**
 * Declare Variable
 */
const defaultStashByOptionGroupState = []
const defaultStashByRadioGroupState = []

/**
 * Export
 */
export const stashByOptionGroups = handleActions({

  ADD_STASH_BY_OPTION_GROUP: (state, action) => {
    const _option = array.head(action.payload.options)
    const _filter = collection.filter(state, function (findResult) {
      return findResult.groupId === action.payload.groupId
    })

    if (!lang.isEmpty(_filter)) {
      const _data = _filter.map(group => {
        if (group.optionType === 'stepper') {
          const optionIndex = array.findIndex(group.options, function (result) {
            return result.id === _option.id
          })

          if (optionIndex !== -1) {
            const nextOptions = update(group.options, {
              [optionIndex]: {
                quantity: {
                  $set: _option.stepperValue,
                },
                stepperValue: {
                  $set: _option.stepperValue,
                },
              },
            })

            const nextGroup = update(group, {
              groupOptionQty: {
                $set: group.groupOptionQty + 1,
              },
              options: {
                $merge: nextOptions,
              },
            })

            return nextGroup
          } else {
            _option.quantity = _option.stepperValue

            const nextGroup = update(group, {
              groupOptionQty: {
                $set: group.groupOptionQty + 1,
              },
              options: {
                $push: [_option],
              },
            })

            return nextGroup
          }
        } else {
          if (group.optionType === 'checkbox') {
            const nextGroup = update(group, {
              groupOptionQty: {
                $set: group.groupOptionQty + 1,
              },
              options: {
                $push: [_option],
              },
            })

            return nextGroup
          } else {
            const nextGroup = update(group, {
              groupOptionQty: {
                $set: 1,
              },
              options: {
                $set: [_option],
              },
            })
            return nextGroup
          }
        }
      })

      const stashIndex = array.findIndex(state, function (findResult) {
        return findResult.groupId === action.payload.groupId
      })
      const nextState = update(state, {
        [stashIndex]: {
          groupOptionQty: {
            $set: _data[0].groupOptionQty,
          },
          options: {
            $merge: _data[0].options,
          },
        },
      })

      return nextState
    } else {
      if (action.payload.optionType === 'stepper') {
        const nextOptions = update(_option, {
          quantity: {
            $set: _option.stepperValue,
          },
          stepperValue: {
            $set: _option.stepperValue,
          },
        },
        )

        const optionIndex = array.findIndex(action.payload.options, function (result) {
          return result.id === nextOptions.id
        })

        const nextGroup = update(action.payload, {
          options: {
            [optionIndex]: {
              quantity: {
                $set: nextOptions.quantity,
              },
              stepperValue: {
                $set: nextOptions.stepperValue,
              },
            },
          },
        })

        return [
          ...state,
          nextGroup,
        ]
      } else {
        return [
          ...state,
          action.payload,
        ]
      }
    }
  },

  REMOVE_STASH_BY_OPTION_GROUP: (state, action) => {
    const _option = array.head(action.payload.options)
    const _filter = collection.filter(state, function (findResult) {
      return findResult.groupId === action.payload.groupId
    })

    if (!lang.isEmpty(_filter)) {
      const _data = _filter.map(group => {
        if (group.optionType === 'stepper') {
          const optionIndex = array.findIndex(group.options, function (result) {
            return result.id === _option.id
          })

          if (_option.stepperValue !== 0) {
            const nextOptions = update(group.options, {
              [optionIndex]: {
                quantity: {
                  $set: _option.stepperValue,
                },
                stepperValue: {
                  $set: _option.stepperValue,
                },
              },
            })

            const nextGroup = update(group, {
              groupOptionQty: {
                $set: group.groupOptionQty - 1,
              },
              options: {
                $merge: nextOptions,
              },
            })

            return nextGroup
          } else {
            const nextOptions = update(group, {
              groupOptionQty: {
                $set: group.groupOptionQty - 1,
              },
              options: {
                $splice: [
                  [optionIndex, 1],
                ],
              },
            },
            )

            return nextOptions
          }
        } else {
          if (group.optionType === 'checkbox' || group.optionType === 'radio') {
            const stashIndexOfGroupOptions = array.findIndex(group.options, function (findResult) {
              return findResult.name === _option.name
            })
            const nextStateOfGroupOptions = update(group, {
              groupOptionQty: {
                $set: group.groupOptionQty - 1,
              },
              options: {
                $splice: [
                  [stashIndexOfGroupOptions, 1],
                ],
              },
            },
            )
            return nextStateOfGroupOptions
          } else {
            return null
          }
        }
      })

      const stashIndex = array.findIndex(state, function (findResult) {
        return findResult.groupId === action.payload.groupId
      })

      const nextState = update(state, {
        $splice: [
          [stashIndex, 1, _data[0]],
        ],
      },
      )

      return nextState
    }
  },

  RESET_STASH_BY_OPTION_GROUP: (state, action) => {
    state = defaultStashByOptionGroupState
    return state
  },

}, defaultStashByOptionGroupState)

export const stashByRadioGroups = handleActions({

  ADD_STASH_BY_RADIO_GROUP: (state, action) => {
    const objectKey = array.head(object.keys(action.payload))
    const objectValue = action.payload[objectKey]
    const hasSameKey = object.has(state, objectKey)

    if (hasSameKey) {
      const _stateObjectValue = state[objectKey]
      if (objectValue === _stateObjectValue) {
        return {
          ...state,
          [objectKey]: null,
        }
      }
    }

    return {
      ...state,
      [objectKey]: objectValue,
    }
  },

  RESET_STASH_BY_RADIO_GROUP: (state, action) => {
    state = defaultStashByRadioGroupState
    return state
  },

}, defaultStashByRadioGroupState)

export default {
  stashByOptionGroups,
  stashByRadioGroups,
}



// WEBPACK FOOTER //
// ./src/reducers/components/optionGroups.js